module.exports = __webpack_public_path__ + "static/media/waiting-process.233d58c7.png";